import { Action } from 'redux';
import { ActionTypeNames } from './actions';

export function startLoading(): Action<ActionTypeNames.StartLoading> {
    return {
        type: ActionTypeNames.StartLoading
    };
}
export function endLoading(): Action<ActionTypeNames.EndLoading> {
    return {
        type: ActionTypeNames.EndLoading
    };
}
